import React from 'react';

export function SkeletonLine({ width = '100%', height = '1rem', style = {} }) {
  return (
    <div
      className="skeleton-shimmer"
      style={{
        width,
        height,
        borderRadius: 'var(--radius-sm, 0.25rem)',
        ...style,
      }}
    />
  );
}

export function SkeletonCircle({ size = '2.5rem', style = {} }) {
  return (
    <div
      className="skeleton-shimmer"
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        flexShrink: 0,
        ...style,
      }}
    />
  );
}

export function SkeletonCard({ style = {} }) {
  return (
    <div style={{
      background: 'white',
      borderRadius: 'var(--radius-xl, 1rem)',
      padding: '1.25rem',
      boxShadow: 'var(--shadow-sm, 0 2px 8px rgba(0,0,0,0.08))',
      ...style,
    }}>
      <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.75rem' }}>
        <SkeletonLine width="60px" height="1.2rem" />
        <SkeletonLine width="50px" height="1.2rem" />
      </div>
      <SkeletonLine width="100%" height="80px" style={{ borderRadius: 'var(--radius-md, 0.5rem)', marginBottom: '0.75rem' }} />
      <SkeletonLine width="90%" height="0.85rem" style={{ marginBottom: '0.4rem' }} />
      <SkeletonLine width="60%" height="0.85rem" style={{ marginBottom: '0.75rem' }} />
      <div style={{ display: 'flex', gap: '0.5rem' }}>
        <SkeletonLine width="100%" height="2rem" />
        <SkeletonLine width="3rem" height="2rem" />
      </div>
    </div>
  );
}

export function SkeletonGrid({ count = 6, columns = 'repeat(auto-fill, minmax(280px, 1fr))' }) {
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: columns,
      gap: '1rem',
    }}>
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          style={{
            opacity: 0,
            animation: 'fadeInUp 0.4s ease forwards',
            animationDelay: `${i * 60}ms`,
          }}
        >
          <SkeletonCard />
        </div>
      ))}
    </div>
  );
}

export function SkeletonDetail() {
  return (
    <div style={{
      background: 'white',
      borderRadius: 'var(--radius-xl, 1rem)',
      padding: '1.5rem',
      boxShadow: 'var(--shadow-lg, 0 10px 40px rgba(0,0,0,0.3))',
      maxWidth: '800px',
      margin: '0 auto',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1.5rem' }}>
        <SkeletonCircle size="2rem" />
        <SkeletonLine width="40%" height="1.3rem" />
      </div>
      <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem' }}>
        <SkeletonLine width="70px" height="1.5rem" style={{ borderRadius: '1rem' }} />
        <SkeletonLine width="60px" height="1.5rem" style={{ borderRadius: '1rem' }} />
        <SkeletonLine width="50px" height="1.5rem" style={{ borderRadius: '1rem' }} />
      </div>
      <SkeletonLine width="150px" height="0.8rem" style={{ marginBottom: '1.5rem' }} />
      <SkeletonLine width="100%" height="250px" style={{ borderRadius: 'var(--radius-md, 0.5rem)', marginBottom: '1.5rem' }} />
      <SkeletonLine width="100%" height="1rem" style={{ marginBottom: '0.5rem' }} />
      <SkeletonLine width="85%" height="1rem" style={{ marginBottom: '0.5rem' }} />
      <SkeletonLine width="70%" height="1rem" style={{ marginBottom: '1.5rem' }} />
      <SkeletonLine width="100%" height="4rem" style={{ borderRadius: 'var(--radius-md, 0.5rem)' }} />
    </div>
  );
}
